import React  from 'react';
import Flatpickr from 'react-flatpickr'
import ChatbotWidget from '../ChatbotWidget.js'
var ReactSuperSelect = require('react-super-select')


class Chatbot extends React.PureComponent  {
	constructor(props) {
		super(props);
		this.state = { 	
			editing: false,
			loading: false,
			page: 'topics'
		};
	}
	
	edit = (intent) => (e) => {
		this.setState({editing: intent, loading: false})
	}
	train = (input) => (e) => {
		this.setState({training: input, loading: false})
	}
	verify  = (input) => (e) => {
		var intent = false
		for(var tent of this.props.data.Chatbot.intents){
			if(tent.displayName == input.intent){
				intent = JSON.parse(JSON.stringify(tent))
			}
		}
		this.setState({editing: intent, training:false, page:'topics', loading: false})
	}
	restore = (backup) => (e) => {
		this.setState({restoring: backup, loading: false})
	}
	ignoreTraining = (input) => (e) => {
		e.stopPropagation()
		this.setState({ignoreTraining: input, loading: false})
	}
	trainSelect = (intent) => (e) => {
		this.setState({trainSelect: intent, loading: false})
	}
	removeTrainSelect = (e) => {
		this.setState({trainSelect: false, loading: false})
	}
	add = (e) => {
		this.setState({editing: 
			{
				"displayName":"",
				"priority":500000,
				"trainingPhrases":[],
				"messages":[]
			}, loading: false})
	}
	addTrainingPhrase = (e) => {
		var newEditing = JSON.parse(JSON.stringify(this.state.editing))
		var newPhrase = {
			name: this.generateUniqueID(),
			parts: [
				{text: e.currentTarget.value}
			],
			type: 'EXAMPLE'
		}
		newEditing.trainingPhrases.push(newPhrase)
		this.setState({editing: newEditing, loading: false})
	}
	editTrainingPhrase = (index) => (e) => {
		var newEditing = JSON.parse(JSON.stringify(this.state.editing))
		newEditing.trainingPhrases[index].parts[0].text = e.currentTarget.value
		this.setState({editing: newEditing, loading: false})
	}
	editDisplayName  = (e) => {
		var newEditing = JSON.parse(JSON.stringify(this.state.editing))
		newEditing.displayName = e.currentTarget.value
		this.setState({editing: newEditing, loading: false})
	}
	deleteTrainingPhrase  = (index) => (e) => {
		var newEditing = JSON.parse(JSON.stringify(this.state.editing))
		newEditing.trainingPhrases.splice(index, 1)
		this.setState({editing: newEditing, loading: false})
	}
	
	addResponse = (e) => {
		var newEditing = JSON.parse(JSON.stringify(this.state.editing))
		var newMessage = {
			text: {
				text: [e.currentTarget.value]
			}
		}
		newEditing.messages.push(newMessage)
		this.setState({editing: newEditing, loading: false})
	}
	addResponseWithType = (option) => {
		if(option && option.id == 'text'){
			var newEditing = JSON.parse(JSON.stringify(this.state.editing))
			var newMessage = {
				text: {
					text: ['']
				}
			}
			newEditing.messages.push(newMessage)
			this.setState({editing: newEditing, loading: false})
		} else if(option && option.id == 'chip'){
			var newEditing = JSON.parse(JSON.stringify(this.state.editing))
			var newMessage = {
				payload: {
					richContent: [[
						{
							type:'chips',
							options: [{link:'', text:''}]
						}
					]]
				}
			}
			newEditing.messages.push(newMessage)
			this.setState({editing: newEditing, loading: false})
		} else if(option && option.id == 'image'){
			var newEditing = JSON.parse(JSON.stringify(this.state.editing))
			var newMessage = {
				payload: {
					richContent: [[
						{
							type:'image',
							accessibilityText: '',
							rawUrl: ''
						}
					]]
				}
			}
			newEditing.messages.push(newMessage)
			this.setState({editing: newEditing, loading: false})
		}
	}
	editResponse = (index, field) => (e) => {
		var newEditing = JSON.parse(JSON.stringify(this.state.editing))
		if(newEditing.messages[index].hasOwnProperty('payload')){
			if(newEditing.messages[index].payload.richContent[0][0].type== 'image'){
				newEditing.messages[index].payload.richContent[0][0][field] = e.currentTarget.value
			} else {
				newEditing.messages[index].payload.richContent[0][0].options[0][field] = e.currentTarget.value
			}
			
		} else {
			newEditing.messages[index].text.text[0] = e.currentTarget.value
		}
		
		

		this.setState({editing: newEditing, loading: false})
	}
	
	deleteResponse = (index) => (e) => {
		var newEditing = JSON.parse(JSON.stringify(this.state.editing))
		newEditing.messages.splice(index, 1)
		this.setState({editing: newEditing, loading: false})
	}
	
	changePage = (page) => (e) => {
		this.setState({page: page, loading: false})
	}
	
	editDescription = (e) =>  {
		if (e.target.value.length < 1){
			this.setState({description: '', error: 'Please enter a description for this prompt.'});
		} else {
			this.setState({description: e.target.value, error: ''});
		}
	}
	cancel = () => {
		this.setState({editing: false, deleting: false, training:false,restoring:false, deletingBackup: false, trainSelect:false, ignoreTraining:false, loading: false})
	}
	confirmEdit = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({route: 'editIntent', intent: this.state.editing }))		
		
	}
	confirmRestore = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({route: 'restoreBackup', backup: this.state.restoring }))		
		
	}
	exportBackup  = (backup) => e => {
		e.stopPropagation()
		this.props.ws.send(JSON.stringify({route: 'exportBackup', backup: backup }))			
	}
	confirmTrain = () => {
		this.setState({ loading: true });
		var newEditing = JSON.parse(JSON.stringify(this.state.trainSelect))
		var newPhrase = {
			name: this.generateUniqueID(),
			parts: [
				{text: this.state.training.input}
			],
			type: 'EXAMPLE'
		}
		newEditing.trainingPhrases.push(newPhrase)
		this.props.ws.send(JSON.stringify({route: 'trainIntent', training:this.state.training, intent: newEditing }))		
		
	}
	confirmIgnoreTraining = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({route: 'ignoreTraining', training:this.state.ignoreTraining }))		
		
	}
	createBackup = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({route: 'createBackup' }))		
	}
	
	delete = (intent) => e => {
		e.stopPropagation()
		this.setState({deleting: intent, loading: false, error: ''})
	}
	confirmDelete = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({route: 'deleteIntent', intent: this.state.deleting }))		
	}
	
	deleteBackup = (backup) => (e) => {
		e.stopPropagation()
		this.setState({deletingBackup: backup, loading: false, error: ''})
	}
	confirmDeleteBackup  = (e) => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({route: 'deleteBackup', backup: this.state.deletingBackup }))		
	}
	toggleApplication = (option) =>  {
		if(option){
			this.setState({application: option.name, error: ''});
		}
	}
	toggleMessageType = (option) =>  {
		if(option){
			var newEditing = JSON.parse(JSON.stringify(this.state.editing))
			
			this.setState({application: option.name, error: ''});
		}
	}
	sample = () => {
		if(!this.state.sampling){
			this.setState({sampling: 'in progress'});
			setTimeout(()=>{
				this.setState({sampling: true});
			}, 1000)
		} else {
			this.setState({sampling: false});
			setTimeout(()=>{
				this.setState({sampling: undefined});
			}, 1000)
		} 
	}
	checkEnter = (e) => {
		if(e.keyCode === 13){
			this.confirmEdit();
		}
	}
	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel()
		}
	}
	 generateUniqueID = () => {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}
	render() {
		if (this.props.active && this.state.page == 'topics') {	
			var intents = this.props.data.Chatbot.intents.sort((a,b)=>{return a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1})
			console.log(intents)
			var intentList = []
			
			for (var intent of intents) {
				intentList.push(
					<div className="dataRow" key={intent.name} onClick={this.edit(intent)}>
						<span style={{flex: '1 0 300px'}}>{intent.displayName}</span>
						<span style={{flex: ' 0 1 200px'}}>{intent.trainingPhrases ? intent.trainingPhrases.length : 0}</span>
						<span style={{flex: ' 0 1 200px'}}>{intent.messages.length}</span>
						<span className="buttonBox" style={{flex: '0 0 80px'}}>
							<img src={this.props.img.delete} alt="Delete Topic" onClick={this.delete(intent)} />
						</span>
					</div>
				)	
			}
			
			var edit = ""
			if (this.state.editing) {
				if(this.state.editing.hasOwnProperty('trainingPhrases')){
					var trainingPhrases = []
					var i = -1
					for (var [i,trainingPhrase] of this.state.editing.trainingPhrases.entries()){
						trainingPhrases.push(
							<div key={'trainingPhrase' +i} style={{display: 'flex'}}>
								<input style={{    display: 'block',   fontSize: '16px', flex: '1 1 90%',    border: '1px solid #2A6AA9',    padding: '5px 10px',    margin: '5px',    boxSizing: 'border-box'}}  placeholder="Input Example" type="text" value={trainingPhrase.parts[0].text} onChange={this.editTrainingPhrase(i)}></input>
							<div style={{lineHeight: '40px',     margin: '0px 10px 0px 5px', cursor: 'pointer'}} onClick={this.deleteTrainingPhrase(i)}>X</div>
							</div>
						)
					}
					trainingPhrases.push(
					<div key={'trainingPhrase' +(i +1)}  style={{display: 'flex'}}>
						<input onChange={this.addTrainingPhrase} value="" style={{    display: 'block',  fontSize: '16px', flex: '1 1 90%',   width: '100%',    border: '1px solid #2A6AA9',    padding: '5px 10px',    margin: '5px',    boxSizing: 'border-box'}} type="text" placeholder="Add Input Example"></input>
					</div>
					)
				} else {
					trainingPhrases = (<div style={{padding: '10px', color: '#000'}}>This topic does not allow any example input.</div>)
				}
				var messages = []
				i = -1
				for (var [i,message] of this.state.editing.messages.entries()){
					if(message.hasOwnProperty('text')){
						messages.push(
							<div key={'response' +i} style={{display: 'flex', marginLeft: '5px'}}>
								<div  style={{ flex: '0 0 120px' }} >
									<ReactSuperSelect onChange={this.toggleMessageType} initialValue={{id: 'text', name: 'Text'}} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{id: 'text', name: 'Text'}, {id: 'chip', name: 'Link'}, {id: 'image', name: 'Image'}]} />
								</div>
								<input style={{flex: '5 5  70%',  fontSize: '16px', height: '30px', border: '1px solid rgb(42, 106, 169)',    padding: '5px 10px',    margin: '5px 5px 5px 0px',    boxSizing: 'border-box'}}  type="text" onChange={this.editResponse(i)} placeholder="Response Text" value={message.text.text}></input>
								<div style={{lineHeight: '37px' ,     margin: '0px 10px 0px 5px', cursor: 'pointer'}} onClick={this.deleteResponse(i)}>X</div>
							</div>
						)
					}else if(message.hasOwnProperty('payload')){
						if(message.payload.richContent[0][0].type == 'image'){
							messages.push(
								<div key={'response' +i} style={{display: 'flex', margin: '5px'}}>
									<div  style={{ flex: '0 0 120px' }} >
										<ReactSuperSelect onChange={this.toggleMessageType} initialValue={{id: 'image', name: 'Image'}} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{id: 'text', name: 'Text'}, {id: 'chip', name: 'Link'}, {id: 'image', name: 'Image'}]} />
									</div>
									<input style={{flex: '1 1  auto',maxWidth: '35%', fontSize: '16px', height: '30px', border: '1px solid rgb(42, 106, 169)',    padding: '5px 10px',    margin: '5px 0px 5px 0px',    boxSizing: 'border-box'}}  type="text" onChange={this.editResponse(i,'altText') } placeholder="Alternate Text" value={message.payload.richContent[0][0].accessibilityText}></input>
									<input style={{flex: '1 1  auto', fontSize: '16px', height: '30px', border: '1px solid rgb(42, 106, 169)',    padding: '5px 10px',    margin: '5px 5px 5px 0px',    boxSizing: 'border-box'}}  type="text" onChange={this.editResponse(i,'image')} placeholder="URL for Image" value={message.payload.richContent[0][0].rawUrl}></input>
									<div style={{lineHeight: '40px', padding: '0px 5px'}} onClick={this.deleteResponse(i)}>X</div>
								</div>
							)
						} else {
							messages.push(
								<div key={'response' +i} style={{display: 'flex', margin: '5px'}}>
									<div  style={{ flex: '0 0 120px' }} >
										<ReactSuperSelect onChange={this.toggleMessageType} initialValue={{id: 'chip', name: 'Link'}} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{id: 'text', name: 'Text'}, {id: 'chip', name: 'Link'}, {id: 'image', name: 'Image'}]} />
									</div>
									<input style={{flex: '1 1  auto', maxWidth: '35%',fontSize: '16px', height: '30px', border: '1px solid rgb(42, 106, 169)',    padding: '5px 10px',    margin: '5px 0px 5px 0px',    boxSizing: 'border-box'}}  type="text" onChange={this.editResponse(i,'text') } placeholder="Visible Text" value={message.payload.richContent[0][0].options[0].text}></input>
									<input style={{flex: '1 1  auto', fontSize: '16px', height: '30px', border: '1px solid rgb(42, 106, 169)',    padding: '5px 10px',    margin: '5px 5px 5px 0px',    boxSizing: 'border-box'}}  type="text" onChange={this.editResponse(i,'link')} placeholder="URL for Link" value={message.payload.richContent[0][0].options[0].link}></input>
									<div style={{lineHeight: '40px', padding: '0px 5px'}} onClick={this.deleteResponse(i)}>X</div>
								</div>
							)
						}
						
					}
					
				}

				messages.push(
					<div key={'response' +(i+1)} style={{display: 'flex', margin: '5px'}}>
						<div  style={{ flex: '0 1 120px' }} >
							<ReactSuperSelect onChange={this.addResponseWithType} initialValue={null} placeholder="Add" clearable={false} closeOnSelectedOptionClick={false} dataSource={[{id: 'text', name: 'Text'}, {id: 'chip', name: 'Link'},{id: 'image', name: 'Image'}]} />
						</div>
						<input style={{flex: '1 1  auto',fontSize: '16px', height: '30px', border: '1px solid rgb(42, 106, 169)',    padding: '5px 10px',    margin: '5px 0px 5px 0px',    boxSizing: 'border-box'}} type="text" onChange={this.addResponse} value="" placeholder="Add Another Response"  ></input>
					</div>
				)
				edit = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>Topic Name</div>
							<div style={{display: 'flex'}}>
								<input style={{    display: 'block', fontSize: '16px', flex: '1 1 90%',    width: '100%',    border: '1px solid #2A6AA9',    padding: '5px 10px',    margin: '5px',    boxSizing: 'border-box'}}  type="text" onChange={this.editDisplayName} value={this.state.editing.displayName} placeholder="Topic Name"  ></input>
							</div>
							<br/>
							<div>Example Input</div>
							{trainingPhrases}
							<br/>
							<div>Responses</div>
							{messages}
							
							
							<div className="error" style={{padding: '15px'}}>{this.state.error}</div>
							
							{this.state.loading ? <div className="loader"></div> : <div className="button"  onClick={this.confirmEdit}>Confirm</div>}
						</div>
					</div>
				)
			}
				
				var deleting = ''
				if(this.state.deleting){
					deleting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop">
								<div className="viewCloser" onClick={this.cancel}></div>
								<div>You are removing the topic</div>
								<div> {this.state.deleting.displayName}</div>
								<br/>
								{this.state.loading ? <div className="loader"></div> : <div style={{display: 'flex'}}><div style={{backgroundColor: '#888'}} className="button"  onClick={this.cancel}>Cancel</div><div className="button"  onClick={this.confirmDelete}>Confirm</div></div>}
							</div>
						</div>
					)
				}

			return (
				<div>
					<div style={{transition: 'width 1s',width: this.state.sampling ? 'calc(100% - 400px)' : '100%'}}>
						<img src={this.props.img.plus}  style={ this.state.sampling ? {transition: 'right 1s', right: 'calc(400px + 5vw)' } :   {transition: 'right 1s', right: '5vw' } } className="plusButton" alt="Add a Topic" onClick={this.add} />
						<div style={ this.state.sampling ? {transition: 'right 1s', bottom: 'calc(5vw + 80px)', color: '#fff', backgroundColor: '#2A6AA9', right: 'calc(400px + 5vw)',    height: '65px',    width: '65px',    margin: '5px',    fontSize: '22px',    lineHeight: '65px',    textAlign: 'center'} : {transition: 'right 1s', bottom: 'calc(5vw + 80px)', color: '#fff', backgroundColor: '#2A6AA9', right: '5vw',     height: '65px',    width: '65px',    margin: '5px',    fontSize: '22px',    lineHeight: '65px',    textAlign: 'center'}} className="plusButton" alt="Add a Topic" onClick={this.sample} > {!this.state.sampling ? 'Try It' : 'Done'}</div>
						<div style={{display: 'flex', marginTop: '15px'}}>
							<div  className="button"   onClick={this.changePage('topics')}>Topics</div>
							<div  className="button" style={{backgroundColor: '#888' }} onClick={this.changePage('training')}>Training</div>
							<div   className="button" style={{backgroundColor: '#888' }} onClick={this.changePage('backup')}>Backup/Restore</div>
						</div>
						<div className="dataHeaders">
							<span style={{flex: '1 0 300px', cursor: 'pointer', textAlign: 'left'}} >Topic</span>
							<span style={{flex: '0 1 200px',  textAlign: 'left'}} >Training Phrases</span>
							<span style={{flex: '0 1 200px',  textAlign: 'left'}}>Responses</span>
							<span style={{flex: '0 0 130px'}} ></span>
						</div> 
						<div style={{overflow: 'auto', height: 'calc(100% - 85px)'}}>
							{intentList}
						</div>
						
						{edit}
							{deleting}
					</div>
					{this.state.sampling ?
						<div style={{transition: 'opacity 1s', opacity: this.state.sampling === true ? 1 : 0}}>
							<ChatbotWidget projectID={this.props.data.Chatbot.projectID}  chatTitle={this.props.data.Chatbot.chatTitle} initialMessage={this.props.data.Chatbot.initialMessage}  greeting={this.props.data.Chatbot.greeting} placeholder={this.props.data.Chatbot.placeholder}></ChatbotWidget>
						</div> 
					: '' }
				</div>
			);
		} else if (this.props.active && this.state.page == 'training') {	
		
			var trainingInput = []
			for (var input of this.props.data.Chatbot.training){
				trainingInput.push(
					<div className="dataRow" key={input.input} onClick={this.train(input)}>
						<span style={{flex: '5 0 300px', textAlign: 'left'}}>{input.input}</span>
						<span style={{flex: ' 1 0 100px', textAlign: 'left'}}>{input.count}</span>
						<span className="buttonBox" style={{flex: '0 0 80px'}}>
							<img src={this.props.img.delete} alt="Delete Topic" onClick={this.ignoreTraining(input)} />
						</span>
					</div>
				)
			}
			
			var verificationInput = []
			for (var input of this.props.data.Chatbot.verification){
				verificationInput.push(
					<div className="dataRow" key={input.input} onClick={this.verify(input)}>
						<span style={{flex: '1 0 300px', textAlign: 'left'}}>{input.input}</span>
						<span style={{flex: ' 1 0 200px', textAlign: 'left'}}>{input.intent}</span>
					</div>
				)
			}
			var training = ""
			if (this.state.training && !this.state.trainSelect){
				var intents = this.props.data.Chatbot.intents.sort((a,b)=>{return a.displayName > b.displayName ? 1 : -1})
				var intentList = []
				
				for (var intent of intents) {
					intentList.push(
						<div className="dataRow" style={{minWidth: '400px'}} key={intent.name} onClick={this.trainSelect(intent)}>
							<span style={{flex: '1 0 400px', textAlign: 'left'}}>{intent.displayName}</span>
						</div>
					)	
				}
				
				training = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>Input Received:</div>
							<div> {this.state.training.input}</div>
							<br/>
							<div>Select a Topic to Add This Input:</div>
							{intentList}
							<br/>
						</div>
					</div>
				)
			} else if(this.state.training && this.state.trainSelect){
				training = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>Input Received:</div>
							<div> {this.state.training.input}</div>
							<br/>
							<div>Add This Input to the Following Topic:</div>
							<div> {this.state.trainSelect.displayName}</div>
							<br/>
							{this.state.loading ? <div className="loader"></div> : <div style={{display: 'flex'}}><div style={{backgroundColor: '#888'}} className="button"  onClick={this.removeTrainSelect}>Back</div><div className="button"  onClick={this.confirmTrain}>Confirm</div></div>}
						</div>
					</div>
				)
			} else if (this.state.ignoreTraining){
				training = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop">
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>Ignoring the Input:</div>
							<div> {this.state.ignoreTraining.input}</div>
							<br/>
							<div>All existing occurences of this input will be hidden. It may reappear if the input is presented again in the future.</div>
							<br/>
							{this.state.loading ? <div className="loader"></div> : <div style={{display: 'flex'}}><div style={{backgroundColor: '#888'}} className="button"  onClick={this.cancel}>Cancel</div><div className="button"  onClick={this.confirmIgnoreTraining}>Confirm</div></div>}
						</div>
					</div>
				)
			}
			
			return (
				<div>
					<div style={{transition: 'width 1s',width: this.state.sampling ? 'calc(100% - 400px)' : '100%'}}>
						
						<div style={ this.state.sampling ? {transition: 'right 1s', bottom: '5vw', color: '#fff', backgroundColor: '#2A6AA9', right: 'calc(400px + 5vw)',    height: '65px',    width: '65px',    margin: '5px',    fontSize: '22px',    lineHeight: '65px',    textAlign: 'center'} : {transition: 'right 1s', bottom: 'calc(5vw + 80px)', color: '#fff', backgroundColor: '#2A6AA9', right: '5vw',     height: '65px',    width: '65px',    margin: '5px',    fontSize: '22px',    lineHeight: '65px',    textAlign: 'center'}} className="plusButton" alt="Add a Topic" onClick={this.sample} > {!this.state.sampling ? 'Try It' : 'Done'}</div>
					<div style={{display: 'flex', marginTop: '15px'}}>
						<div className="button" style={{backgroundColor: '#888' }} onClick={this.changePage('topics')}>Topics</div>
						<div   className="button"  onClick={this.changePage('training')}>Training</div>
						<div   className="button" style={{backgroundColor: '#888' }} onClick={this.changePage('backup')}>Backup/Restore</div>
					</div>
					<h3>Add Unmatched Inputs to Topics</h3>
					<div className="dataHeaders">
						<span style={{flex: '5 0 300px', cursor: 'pointer', textAlign: 'left'}} >Input Received</span>
						<span style={{flex: '1 0 100px',  textAlign: 'left'}} >Frequency</span>
						<span style={{flex: '0 0 130px'}} ></span>
					</div> 
					<div style={{overflow: 'auto', height: 'calc(100% - 85px)'}}>
						{trainingInput}
					</div>
					<hr/>
					<h3>Verify Recent Topic Selection</h3>
					<div className="dataHeaders">
						<span style={{flex: '1 0 300px', cursor: 'pointer', textAlign: 'left'}} >Input Received</span>
						<span style={{flex: '1 0 200px',  textAlign: 'left'}} >Topic Matched</span>
					</div> 
					<div style={{overflow: 'auto', height: 'calc(100% - 85px)'}}>
						{verificationInput}
					</div>
					{training}
					{edit}
				</div>
					{this.state.sampling ?
						<div style={{transition: 'opacity 1s', opacity: this.state.sampling === true ? 1 : 0}}>
							<ChatbotWidget projectID={this.props.data.Chatbot.projectID}  chatTitle={this.props.data.Chatbot.chatTitle } ></ChatbotWidget>
						</div> 
					: '' }
				</div>
				)
		} else if (this.props.active && this.state.page == 'backup') {	
		
			var backupList = this.props.data.Chatbot.backups ? this.props.data.Chatbot.backups.sort((a,b) => {return a > b ? -1:1}) : []
			var backups = []
				for (var backup of backupList){
					backups.push(
						<div className="dataRow" style={{maxWidth: '400px'}} key={backup} onClick={this.restore(backup)}>
							<span style={{flex: '5 1 300px', textAlign: 'left'}}>{new Date(parseInt(backup.replace('.zip', ''))).toLocaleString()}</span>
							<span className="buttonBox" style={{flex: '0 0 80px'}}>
								<img src={this.props.img.whiteDownload} alt="Export" onClick={this.exportBackup(backup)} />
								<img src={this.props.img.delete} alt="Delete Backup" onClick={this.deleteBackup(backup)} />
							</span>
						</div>
					)
				}
				var restore= ''
				if(this.state.restoring){
					restore = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop">
								<div className="viewCloser" onClick={this.cancel}></div>
								<div>Do you really want to restore to the backup from</div>
								<div> {new Date(parseInt(this.state.restoring.replace('.zip', ''))).toLocaleString()} ?</div>
								<br/>
								<div>Any changes made since that time will be lost. Consider creating a new backup before restoring.</div>
								<br/>
								{this.state.loading ? <div className="loader"></div> : <div style={{display: 'flex'}}><div style={{backgroundColor: '#888'}} className="button"  onClick={this.cancel}>Cancel</div><div className="button"  onClick={this.confirmRestore}>Confirm</div></div>}
							</div>
						</div>
					)
				}
				
				var deleting = ''
				if(this.state.deletingBackup){
					deleting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop">
								<div className="viewCloser" onClick={this.cancel}></div>
								<div>You are removing the backup from</div>
								<div> {new Date(parseInt(this.state.deletingBackup.replace('.zip', ''))).toLocaleString()} ?</div>
								<br/>
								{this.state.loading ? <div className="loader"></div> : <div style={{display: 'flex'}}><div style={{backgroundColor: '#888'}} className="button"  onClick={this.cancel}>Cancel</div><div className="button"  onClick={this.confirmDeleteBackup}>Confirm</div></div>}
							</div>
						</div>
					)
				}
			return (
					<div>
					<div style={{transition: 'width 1s',width: this.state.sampling ? 'calc(100% - 400px)' : '100%'}}>
						<img src={this.props.img.plus}  style={ this.state.sampling ? {transition: 'right 1s', right: 'calc(400px + 5vw)' } :   {transition: 'right 1s', right: '5vw' } } className="plusButton" alt="Create a New Backup" onClick={this.createBackup} />
						<div style={ this.state.sampling ? {transition: 'right 1s', bottom: 'calc(5vw + 80px)', color: '#fff', backgroundColor: '#2A6AA9', right: 'calc(400px + 5vw)',    height: '65px',    width: '65px',    margin: '5px',    fontSize: '22px',    lineHeight: '65px',    textAlign: 'center'} : {transition: 'right 1s', bottom: 'calc(5vw + 80px)', color: '#fff', backgroundColor: '#2A6AA9', right: '5vw',     height: '65px',    width: '65px',    margin: '5px',    fontSize: '22px',    lineHeight: '65px',    textAlign: 'center'}} className="plusButton" alt="Add a Topic" onClick={this.sample} > {!this.state.sampling ? 'Try It' : 'Done'}</div>
					
					
					<div style={{display: 'flex', marginTop: '15px'}}>
						<div className="button" style={{backgroundColor: '#888' }}onClick={this.changePage('topics')}>Topics</div>
						<div   className="button"  style={{backgroundColor: '#888' }} onClick={this.changePage('training')}>Training</div>
						<div   className="button"  onClick={this.changePage('backup')}>Backup/Restore</div>
					</div>
					<div className="dataHeaders">
						<span style={{flex: '1 0 300px', cursor: 'pointer', textAlign: 'left'}} >Date/Time of Backup</span>
						<span style={{flex: '0 0 130px'}} ></span>
					</div> 
					<div style={{overflow: 'auto', height: 'calc(100% - 85px)'}}>
						{backups}
					</div>
					{restore}
						{deleting}
					{edit}
						
				</div>
					{this.state.sampling ?
						<div style={{transition: 'opacity 1s', opacity: this.state.sampling === true ? 1 : 0}}>
							<ChatbotWidget projectID={this.props.data.Chatbot.projectID}  chatTitle={this.props.data.Chatbot.chatTitle } ></ChatbotWidget>
						</div> 
					: '' }
				</div>
				)
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuClock"
const roles = ["View", "Add", "Edit", "Delete"]

export { Chatbot, roles, icon }